import { Injectable } from '@angular/core';

import { MapBackdropService } from '@core/services/map-backdrop/map-backdrop.service';

import { GeoLocation } from '@features/components/visualization/mapbox/models/map-data';

export interface ContextSite {
  uid: string;
  name: string;
  coords: GeoLocation;
}

type SiteRow = { uid: string; name?: string; coords?: GeoLocation };

/** The site dots drawn underneath geographic zones, so a zone reads against what it covers. */
@Injectable({ providedIn: 'root' })
export class SiteContextService extends MapBackdropService<SiteRow, ContextSite> {
  protected readonly entityType = 'SITE';
  protected readonly entityName = 'site';

  protected build(rows: SiteRow[]): ContextSite[] {
    return rows
      .filter((site) => !!site.coords)
      .map((site) => ({
        uid: site.uid,
        name: site.name ?? site.uid,
        coords: site.coords!
      }));
  }
}
